import React, { useState } from 'react'
import { useRequestItemStepApprovers } from 'hooks'
import { ApproversList } from 'components'

const take = 9

const RequestItemApprovers = ({ id, stepId, totalCount }) => {
    const [page, setPage] = React.useState(1)
    const [searchTerm, setSearchTerm] = useState('')

    const handlePageChange = (value) => {
        setPage(value)
    }

    const { latestData } = useRequestItemStepApprovers(
        id,
        stepId,
        (page - 1) * take,
        take,
        searchTerm,
    )

    const isLoading = !Boolean(latestData)

    const data = latestData ? latestData.data : undefined

    const numberOfPages = latestData
        ? Math.ceil(latestData.totalCount / take)
        : 0

    return (
        <ApproversList
            totalCount={totalCount}
            visibleCount={latestData && latestData.totalCount}
            isLoading={isLoading}
            data={data}
            page={page}
            handlePageChange={handlePageChange}
            numberOfPages={numberOfPages}
            searchTerm={searchTerm}
            handleSearch={setSearchTerm}
        />
    )
}

export default RequestItemApprovers
